/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * External dependencies
 */
import classnames from 'classnames';

export default function save( { attributes, clientID, className } ) {
	const { align, blockClientId, stretchContainer } = attributes;

	const _blockClientId = '' !== blockClientId ? blockClientId : clientID;

	const wrapperClasses = classnames(
		className,
		`align${ align }`,
		stretchContainer ? 'gutenify-container-stretch' : '',
		'gutenify-block-container-wrapper'
	);

	return (
		<div className={ wrapperClasses }>
			<div id={ `gutenify-section-${ _blockClientId }` }>
				<div className="gutenify-container-background"></div>
				<div className="gutenify-container">
					<InnerBlocks.Content />
				</div>
			</div>
		</div>

	);
}

